/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyDeliveryPostalAreaTypename = "PharmacyDeliveryPostalArea" as const;

/**
 *
 * @export
 * @interface PharmacyDeliveryPostalArea
 */
export interface PharmacyDeliveryPostalArea {
  /**
   *
   * @type {string}
   * @memberof PharmacyDeliveryPostalArea
   */
  postalCodeKey: string;
  /**
   *
   * @type {number}
   * @memberof PharmacyDeliveryPostalArea
   */
  priority: number;
  /**
   *
   * @type {string}
   * @memberof PharmacyDeliveryPostalArea
   */
  provider: PharmacyDeliveryPostalAreaProviderEnum;
  /**
   *
   * @type {string}
   * @memberof PharmacyDeliveryPostalArea
   */
  providerServiceType: PharmacyDeliveryPostalAreaProviderServiceTypeEnum;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyDeliveryPostalArea
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PharmacyDeliveryPostalAreaProviderEnum {
  Mccm = "mccm",
} /**
 * @export
 * @enum {string}
 */
export enum PharmacyDeliveryPostalAreaProviderServiceTypeEnum {
  Inhouse = "mccm_inhouse",
  Outside = "mccm_outside",
}

export function PharmacyDeliveryPostalAreaFromJSON(json: any): PharmacyDeliveryPostalArea {
  return PharmacyDeliveryPostalAreaFromJSONTyped(json, false);
}

export function PharmacyDeliveryPostalAreaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacyDeliveryPostalArea {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyDeliveryPostalAreaTypename,

    postalCodeKey: json["postal_code_key"],
    priority: json["priority"],
    provider: json["provider"],
    providerServiceType: json["provider_service_type"],
  };
}

export function PharmacyDeliveryPostalAreaToJSON(object?: PharmacyDeliveryPostalArea | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    postal_code_key: value.postalCodeKey,
    priority: value.priority,
    provider: value.provider,
    provider_service_type: value.providerServiceType,
  };
}
